import { Link } from "react-router-dom";
import styled from "styled-components";

const WrapperItem = styled.div`
  position: relative;

  .copy-code {
    cursor: pointer;

    position: relative;
    z-index: 15;
    right: 30px;

    width: 100px;
    margin-left: 20px;

    font-weight: 500;
    color: #04d397;

    @media (max-width: 1024px) {
      width: unset !important;
      position: absolute;
      top: 21px;
      display: inline-flex !important;
      margin-right: 20px;

      align-self: flex-start;
      right: 50px;
    }
  }
`;

const TraderItemWrapper = styled(Link)`
  position: relative;

  text-decoration: none;
  height: 64px;
  display: grid;
  grid-template-columns: 3fr 1fr 1fr 1fr;
  gap: 20px;
  align-items: center;
  padding: 12px;
  background: #191b2e;
  border-radius: 16px;
  transition: 200ms;
  margin-top: 15px;
  overflow: hidden;

  .positive {
    color: #34f5ae;
  }

  .negative {
    color: rgb(246, 71, 93);
  }

  .zero {
    color: #fff;
  }

  .ribbon + .profile {
    @media (max-width: 1023px) {
      &::before {
        display: none;
      }

      .detail {
        margin-left: 50px;
      }
    }
  }

  .ribbon {
    position: fixed;
    background: #e8b80e;
    box-shadow: 0 0 0 999px #e8b80e;
    color: #0c0c0c;
    font-size: 10px;
    font-weight: bold;
    padding: 4px 0;
    clip-path: inset(0 -100%);
    inset: 0 auto auto 0;
    transform-origin: 100% 0;
    transform: translate(-29.3%) rotate(-45deg);
    position: absolute;
    z-index: 999;
  }

  .ribbon-alpha {
    background: #bbc1ff;
    box-shadow: #bbc1ff 0px 0px 0px 999px;
  }

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    height: fit-content;
    align-items: flex-end;

    > *:not(:first-child) {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &::before {
        content: attr(data-name);
        text-transform: capitalize;
        color: rgb(175, 175, 175) !important;
      }
    }
  }

  .markPrice,
  .entryPrice {
    @media (min-width: 1024px) {
      display: none;
    }
  }

  &:hover {
    scale: 1.02;
  }

  > * {
    flex: 1;
  }

  .wallet {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;

    .avatar {
      @media (max-width: 1024px) {
        margin-left: auto;
      }
    }
  }

  .profile {
    display: flex;
    column-gap: 20px;
    align-items: center;

    @media (max-width: 1024px) {
      flex-direction: row-reverse;
      width: 100%;
      justify-content: space-between;
      border-bottom: 1px solid rgb(54, 54, 54);
      padding-bottom: 10px;

      .rank {
        width: 32px !important;
      }
    }

    //first
    //second
    //third url("")
    .rank {
      width: 64px;
      height: 32px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      top: 0 !important;

      &.top {
        &::after {
          width: 100%;
          position: absolute;
          inset: 0;
          content: "";
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }

        &.top-1 {
          &::after {
            background-image: url("data:image/webp;base64,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");
          }
        }

        &.top-2 {
          &::after {
            background-image: url("data:image/webp;base64,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");
          }
        }

        &.top-3 {
          &::after {
            background-image: url("data:image/webp;base64,UklGRqgHAABXRUJQVlA4WAoAAAAQAAAAWQAAZQAAQUxQSMsEAAABoIZt2zE3ete2bdu28WY6mVoxatu2FdRugzWDVZK6jdmjndqaYJzrR75v8H3vsb8jYgLE/8J73osa0vntO9RzVcwutAs6XKaUy4eeIdDjPS9Rx7d1AE3luRn5lS6A0o8U8fgvAIdS2sqWHZYdB9h0vwKum+oG6lMsUt+6sgloHHWlyS7qfBTw/9ZRBh71F8B+q6leKQKo6CODH7QXIOdp09yW5gdOz5QhjVh4AfDOvsEUl/Y6B3gyWstQt//JB5yIvch4H5cDbEuU4exRArD9DYM9kAFweIwM99STQPPKOw101ZgmoHGFVYbftsENOAZcZhSbHWjO7yqNGVcEUP2FIZ7JA6gbKI074gDAD4+E7ca5XuD8/AhpZEt6A+CadE1YLo4/Cfh+bC+N3ukPP3CofRje2glQ3EOasV8VwL8vhOiu1c3AicnSrHPOAr7FN4fg8kEOwLXOJs3bNtsLnOl+STCv1wAUxEpzJ+8EKH4msCQ3YB8hzT/+KNDQPpBUoD7VIlVoXeUEJuv1BqqjpSoT7UBHrdfckGOV6rQVQf0TLS6qhEqLVKnNDv+1+ATqo6Vak93wghAiA7KkanMgRYjrvDQnKKc/OC4WL8I+qd7TcK+IhEIFlcH7YgBkKygXosRYWK+gn6Cn0dooyTImt/KEh8Z9W76fYVFK5MYzBHpsoVUdPe0Ee3qgKsZ7CP5cvBoGuQjlwXYqsBxD13fM7tLjJxXIXuc0aqZbpZSjD+lcaKUCmXQS/OsjpGZUvRbJSpAxh1gk9TN0hqtBdlouA5yu00MRgc/W8rZSUL5WnVTPArTHqCRh+PCRM1fuRfs/qZJsAs6xqap2lgy3aTwTZfhNAwdXWZUFtfFKWVhSUn7YqUN9lEq0hxZqUaAeKX/UYpiCLE1a6xQkS7QK1GDZtDqg3Vp2JXQqxj8ukLNaNSoYeApoSNKbjHahAlK8tDw8RGuoQ2eR+dqeRHfP+tlTV25H193RfLKfRyfYGVIBcq4vJJukEuQoRwgKpSJkfEkweydJZUjZ/adGPW/VBBl+jQGQbQQprYkj5q7bvGBEnEUaMReihBUKjWHwMnhfvAj7FHQa7hXXeWlOUE5/cFwsRAZkKScHUoQQn0B9tGKS3fCCEOKiSqi0KMVmh/9Ey9fckGNViK0I6p/QEL2A6mhlJNqBjkI3FahPtSjBusoJTBYBJrkB+3AFjDsCNLQXAb9eA1AQY7LknQDFz4ggLx9SD7jWRpqobaYHONPzEhH8XWuageOTTDPrDOBPuUWE9u1dAMXdTdG3CuC/F0XIL048Cfi+b2e4Tr/7gcMdRVhvnO8Fzs+PMJQltR5wTb5GhPvZPIDagQYaYQf46RFhxNZ2oDm3i0FiCwGqvxQGvWpcE9C4rJUBbOtdgGPQZcK4D2QBHBoTtskngOZVdwpjf1IOsC0hLD2KAXa8KQx/aZ9zgGdT65C1/9EHnIy/WJjxtnQ/cHpGaCIWnAe8c28QZn2lCKC8dwgG1QHkPi1MfFHXo4D/145BdM1vBvZHCpNfN90NOJZYArCuaAKaxlwpzP/4rwCHUtpqdFh2HCDjfqHGb+sAmspzM/IrXQBlHwllXjHsDIEe73WJUOlVsbt0CjtcLpR7z3tRQzq/c4f4PwgAVlA4ILYCAABQFQCdASpaAGYAPmUqjkWkIqEbavVUQAZEtIba0uG7iNHiu1lTRVUXfMk856AK+OVUZzP2ia7f83MmxuQgA+Ychy9j+r0EKPA9NV82Gvb6A1htgAo/DJ2tbp6ZWFpLe5iEvs0dA7eAIJjLxXstFpXF0BGn63kF3JqZbegB+cjhjrTLzEufH5J2rAQdhVdeCYDA9aKrVfYp8nVA26nrBjWWi3V3CnuF207TfBGgGPdhmmONAAD+/PjC/ehuSoFwCfv9F1oWnCjmZL9tf3kSVpHK7keUdPvHUFZZNr9Ysh/Fz0VdEL4tJBSxuZJN/Wdr5ETCleMmA2hMZWtsA8XG1mWmuzj/gMj//Z5/r9oMQ0FX/NkgJ8npGC/9E2yd34g7Ct5T8mmtcPwb3oz6iLqeHzos2TW1BxrX4uLRouDT+/UWQElTxfYgyalEc8uV+ikCKi7RZqdohqhYjxfumv3e0jL7UgNwbOKOpZVCYkzwsSHu3iKLoNgYPU4qfkqqbUB06h0DKC/21odMezy6WacYD+xpC7shqMmJBvztvpARr5i3vyVcMulGufOK5BaFAZZgAvl7b32juA3uqq32gnr8yT1absW2OrRpcI1YCKNJO54rAbDkNrAsS1UHhObGkr78xSrVCrek+qCgv9nJdxqpIZtSdrOd33CWGPH8vWRPuWMuXE3JHl0Fx0KSYcBLUp4Pib679vQq3AIerTy1MjveDSJ6azLCg+qoYShbiaNOVkKj+hkwRRVp2gtakncarDIpaVl6fiM4Kg3s6gF/YryPrMMP+4U7WazKNfiK1HlIPMqH/wgiB5J8pXYJoiacSbrU/z5Op0wY80txIG9FAtnwk/cMEFku3wae+zqL6lS90H/SwWSf+4AgC6fRqnizMXarQDH5zA3K/d2TVlQK52Xc9aq2f/bDgAAA");
          }
        }
      }
    }

    .avatar {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      /* background-image: linear-gradient(225deg, rgb(137, 181, 133), rgb(242, 8, 199) 49%, rgb(120, 41, 35)); */
    }

    .detail {
      display: flex;
      align-items: center;
      gap: 8px;

      .Tooltip-handle {
        text-decoration: none;
      }
    }

    .token-info {
      display: flex;
      gap: 8px;
      align-items: center;

      img {
        width: 32px;
        height: 32px;
      }
    }

    .token-detail {
      .name {
        color: #fff;

        span {
          font-weight: 600;
        }

        @media (max-width: 1024px) {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
      }

      .name span {
        font-size: 12px;
        color: #34f5ae;
      }

      .price {
        @media (max-width: 1024px) {
          display: none;
        }

        .title {
          font-size: 12px;
          color: #ffffff8a;
        }
        .value {
          font-size: 12px;
        }
      }
    }
  }

  .PnL {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fa3c58;

    @media (max-width: 1024px) {
      color: #34f5ae;
      img {
        display: none;
      }
    }
    &.positive {
      color: #34f5ae;
    }
  }

  .icon-view {
    position: absolute;
    top: 27px;
    right: 20px;

    @media (max-width: 1024px) {
      display: none;
    }
  }
`;

const StyledAnalyticsContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1024px) {
    width: 100%;
  }

  .filter {
    align-self: flex-end;
    display: flex;
    gap: 10px;
    font-weight: 600;

    > * {
      cursor: pointer;
      padding: 10px 15px;

      &:hover {
        color: #03f5ae;
      }
    }
  }

  .header-table {
    padding: 0 16px;
    width: 100%;
    height: 32px;
    display: grid;
    grid-template-columns: 3fr 1fr 1fr 1fr;
    gap: 20px;
    font-weight: 500;
    margin-bottom: 5px;
    .group-arrow {
      margin-left: 5px;

      .down {
        margin-top: 2px;

        transform: rotate(180deg);
      }
    }

    span {
      display: flex;
      align-items: center;
    }

    div {
      span:first-child {
        justify-content: center;
      }
    }

    @media (max-width: 1024px) {
      display: none;
    }

    .filter {
      display: flex;
      align-items: center;

      span {
        padding: 0;
        display: flex;
        flex-direction: column;

        img {
          cursor: pointer;
          padding: 3px;
        }
      }

      img.down {
        transform: rotate(180deg);
      }
    }

    > * {
      flex: 1;
    }

    > div {
      display: flex;
      align-items: center;
      column-gap: 20px;

      span:first-child {
        width: 64px;
        text-align: center;
        .Tooltip {
          width: fit-content !important;
          margin-left: 4px;
        }
        .Tooltip-handle {
          width: fit-content !important;
        }
        .Tooltip-popup {
          width: fit-content !important;
        }
      }
    }
  }

  .orderedBy {
    align-self: flex-start;
  }

  .header-table {
    width: 100%;
    &.referrals {
      grid-template-columns: 2fr 1fr 1.3fr 1.3fr 1.7fr 1fr 1.3fr;
    }
  }

  .body-table {
    width: 100%;

    &.referrals {
      a {
        grid-template-columns: 2fr 1fr 1.3fr 1.3fr 1.7fr 1fr 1.3fr;
      }

      .Modal-title-bar {
        margin-left: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .Modal-content {
        .Modal-body {
          .header {
            display: flex;

            margin-bottom: 20px;

            > div:nth-child(1) {
              left: 16px;
              position: relative;
            }

            > div:nth-child(-n + 2) {
              flex: 1;
            }

            /* div {
              min-width: 110px;

              margin-right: 10px;

              &:last-child {
                margin-right: 0;
              }
            } */
          }
        }
      }
    }
  }
`;

const TabWrapper = styled.div`
  max-width: calc(1320px + 48px);
  padding-left: 24px;
  padding-right: 24px;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 286px;

  @media (max-width: 1024px) {
    padding: 0 20px;
    max-width: unset;
  }

  .your-referrals {
    span {
      font-size: 16px;
    }

    .box-rewards {
      display: flex;
      justify-content: center;
      align-items: center;

      font-size: 16px;
      margin-top: 20px;
      padding: 64px;

      border: 1px solid #ffffff1a;
    }
  }

  .time-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 26px;
    margin-left: auto;
    /* margin-bottom: 16px; */

    div {
      cursor: pointer;

      line-height: 24px;
      font-size: 14px;
      font-weight: 500;
      color: rgb(185, 185, 185);

      &.active {
        color: #34f5ae;
      }
    }

    @media (max-width: 767px) {
      justify-content: space-between;
    }
  }

  .round-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;

    margin: 20px 0;

    .label {
      font-size: 16px;

      color: #ffffff;
    }

    .select-round {
      cursor: pointer;

      display: flex;
      justify-content: space-between;

      width: 210px;
      padding: 10px 16px;

      border: 1px solid #ffffff1a;

      font-size: 16px;

      img {
        width: 16px;

        transform: rotate(180deg);
      }
    }
  }

  .filter-block {
    color: rgb(173, 171, 171);
    align-items: center;
  }
`;

const StyledPagination = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: flex-start;
  margin-top: 20px;

  .rowsPerPage {
    select.decorated option:hover {
      box-shadow: 0 0 10px 100px #1882a8 inset;
      background: red;
    }
  }

  select {
    padding: 5px 10px;
    outline: none;
    background: transparent;
    border: 1px solid #ffffff1a;
    color: white;

    > * {
      color: black;
    }
  }

  option {
    background: #110e36;
    color: white;
  }

  .movePage {
    display: flex;
    align-items: center;
    span {
      margin: 0 8px;
    }
  }

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
`;

export { WrapperItem, TraderItemWrapper, StyledAnalyticsContent, StyledPagination, TabWrapper };
